import React from 'react';
import PropTypes from 'prop-types';

import AutoSuggestInput from '../core/AutoSuggestInput';
import { formatAbnOrAcn } from '../../utils/formatter';

const AbnAutoSuggest = ({
  getSuggestions,
  onSuggestionSelected,
  suggestions,
  delay,
  onKeyPress,
  onKeyUp,
  autoFocus,
  fixedIdLabelValue,
}) => {
  let topSuggestions = [];
  const { rows, keyword, isLoading } = suggestions;

  if (rows && rows.length > 0) {
    const keywordLowerCase = keyword.toLowerCase();
    topSuggestions = rows.slice(0, 5).map((x) => {
      if (fixedIdLabelValue === 'ACN' || (x.acn && x.acn === keyword)) {
        const displayText = `${x.entityName} ACN: ${formatAbnOrAcn(x.acn)}`;
        const enriched = {
          displayText,
          isTrustee: true,
        };
        Object.assign(enriched, x);
        return enriched;
      }

      const displayText = `${x.entityName} ABN: ${formatAbnOrAcn(x.id)}`;
      const businessName = x.businessNames
        ? x.businessNames.filter((item) => item.toLowerCase().indexOf(keywordLowerCase) > -1)
        : '';
      const enriched = {
        displayText:
          businessName.length > 0 ? `${displayText} (trading as ${businessName})` : displayText,
        isTrustee: false,
      };
      if (x.acn && businessName.length > 0) {
        enriched.displayText = `${enriched.displayText} ACN: ${formatAbnOrAcn(x.acn)}`;
      }
      Object.assign(enriched, x);
      return enriched;
    });
  }

  return (
    <AutoSuggestInput
      getSuggestions={getSuggestions}
      getSuggestionValue={(x) => x.displayText}
      onSuggestionSelected={onSuggestionSelected}
      suggestions={topSuggestions}
      isGetSuggestionsDone={!isLoading}
      delay={delay}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
      autoFocus={autoFocus}
    />
  );
};

AbnAutoSuggest.propTypes = {
  getSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  delay: PropTypes.number,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  autoFocus: PropTypes.bool,
  suggestions: PropTypes.object.isRequired,
  fixedIdLabelValue: PropTypes.string,
};

AbnAutoSuggest.defaultProps = {
  delay: 500,
  onKeyPress: null,
  onKeyUp: null,
  autoFocus: false,
  fixedIdLabelValue: null,
};

export default AbnAutoSuggest;
